import { useState } from 'react';

import ModalContainer from '../modalContainer';
import './style.scss';
import DeleteBeneficiaryModal from '../deleteBeneficiaryModal';
import { useNavigate } from 'react-router-dom';

function UserCard({ user, backTo, onDeleted }) {
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const navigate = useNavigate();

  function editBeneficiary() {
    navigate(`/caracterizacion/edit/${user.id}`, {
      state: { backTo }
    });
  }

  return (
    <>
      {' '}
      {openModalDelete && (
        <ModalContainer>
          <DeleteBeneficiaryModal
            user={user}
            setOpenModalDelete={setOpenModalDelete}
            backTo={backTo}
            onDeleted={onDeleted}
          />
        </ModalContainer>
      )}
      <div className='benf' key={user.id}>
        <div className='benf__info info'>
          <span className='info__name'>{user.full_name}</span>
          <span className='info__field'>Zona</span>
          <span className='info__field'>Identificación</span>
          <span className='info__value'>{user.document}</span>
          <span className='info__value'>{user.document_type}</span>
        </div>
        <div className='benf__actions actions'>
          <button
            className='actions__btn btn actions__btn--edit'
            onClick={() => editBeneficiary()}>
            <span className='material-symbols-rounded btn__edit'>
              edit_square
            </span>
            <span className='btn__text'>Editar perfil</span>
          </button>
          <button
            className='actions__btn btn actions__btn--delete'
            onClick={() => setOpenModalDelete(true)}>
            <span className='material-symbols-rounded btn__delete'>delete</span>
          </button>
        </div>
      </div>
    </>
  );
}

export default UserCard;
